/**
 * Build metadata baked into the bundle at build time via Vite `define`
 * (see vite.config.ts).
 *
 * - `APP_VERSION` — the product version from package.json (e.g. "0.26.0")
 * - `APP_BUILD` — the git short SHA injected by scripts/deploy.sh through
 *   the VITE_APP_BUILD env var; "dev" for local builds
 * - `APP_BUILT_AT` — ISO timestamp captured when the bundle was built
 *
 * The `typeof` guards keep these safe in contexts where the globals aren't
 * defined (tests, SSG module loading).
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "0.0.0";
export const APP_BUILD: string =
  typeof __APP_BUILD__ === "string" ? __APP_BUILD__ : "dev";
export const APP_BUILT_AT: string =
  typeof __APP_BUILT_AT__ === "string" ? __APP_BUILT_AT__ : "";

/**
 * Compare two dotted version strings numerically.
 * Returns > 0 when `a` is newer than `b`, < 0 when older, 0 when equal.
 */
export function compareVersions(a: string, b: string): number {
  const pa = a.split(".").map((n) => parseInt(n, 10) || 0);
  const pb = b.split(".").map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}
